export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  EDITOR: 'editor',
  STUDENT: 'student',
};

export const ROLE_LABELS = {
  super_admin: 'مشرف عام',
  admin: 'مدير',
  editor: 'محرر',
  student: 'طالب',
};

export const ROLE_HIERARCHY = {
  super_admin: 3,
  admin: 2,
  editor: 1,
  student: 0,
};

export const ADMIN_ROLES = [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.EDITOR];

export function canManageUsers(role) {
  return role === ROLES.SUPER_ADMIN;
}

export function canDeleteGroups(role) {
  return role === ROLES.SUPER_ADMIN || role === ROLES.ADMIN;
}

export function canViewStats(role) {
  return role === ROLES.SUPER_ADMIN || role === ROLES.ADMIN;
}

export function canViewReports(role) {
  return role === ROLES.SUPER_ADMIN || role === ROLES.ADMIN;
}

export function canViewAllContent(role) {
  return role === ROLES.SUPER_ADMIN || role === ROLES.ADMIN || role === ROLES.EDITOR;
}

export function canDeleteContent(role) {
  return role === ROLES.SUPER_ADMIN || role === ROLES.ADMIN;
}

export function canCreateContent(role) {
  return role === ROLES.SUPER_ADMIN || role === ROLES.ADMIN || role === ROLES.EDITOR;
}

export function hasMinRole(role, minRole) {
  if (!role || !(role in ROLE_HIERARCHY)) return false;
  return ROLE_HIERARCHY[role] >= (ROLE_HIERARCHY[minRole] || 0);
}
